import _defineProperty from '../../../node_modules/@babel/runtime/helpers/esm/defineProperty.js';
import React__default from 'react';
import makeStyles from '@material-ui/core/styles/makeStyles';
import { Grid, Box, Link } from '@material-ui/core';
import Typography from '@material-ui/core/Typography';
import PropTypes__default from 'prop-types';
import Card from '@material-ui/core/Card';
import CardContent from '@material-ui/core/CardContent';
import clsx from 'clsx';
import { useBreakpoints } from '../../hooks/useBreakpoints.js';
import CustomRichTextFromMarkdown from '../../widgets/text/CustomRichTextFromMarkdown.js';
import { retrieveContentfulImage } from '../../common/image.js';
import { LazyLoadImage } from 'react-lazy-load-image-component';

var useStyles = makeStyles(function (theme) {
  return {
    box: {
      padding: theme.spacing(5, 2, 0, 2),
      textAlign: "center"
    },
    cardLayout: {
      minWidth: 300,
      maxWidth: 400,
      display: "flex",
      flexDirection: "column",
      margin: "0 auto",
      height: "100%",
      position: "relative"
    },
    cardLayoutOdd: {
      marginRight: "auto !important",
      minWidth: 300,
      maxWidth: 400,
      height: "100%",
      position: "relative",
      display: "flex",
      flexDirection: "column"
    },
    cardLayoutEven: {
      marginLeft: "auto !important",
      minWidth: 300,
      maxWidth: 400,
      height: "100%",
      position: "relative",
      display: "flex",
      flexDirection: "column"
    },
    cardContentStyle: {
      paddingLeft: theme.spacing(5.5),
      paddingRight: theme.spacing(5.5),
      paddingBottom: theme.spacing(5)
    },
    cardTitle: {
      marginBottom: theme.spacing(2)
    },
    img: {
      width: theme.spacing(22.5),
      height: theme.spacing(22.5),
      transform: "rotate(-30deg)"
    },
    gridImg: {
      width: theme.spacing(8),
      height: theme.spacing(8),
      marginTop: theme.spacing(2),
      marginBottom: theme.spacing(2)
    },
    mb2: {
      marginBottom: theme.spacing(2)
    },
    mb4: {
      marginBottom: theme.spacing(4)
    },
    mb5: {
      marginBottom: theme.spacing(5)
    },
    maxWidth1150: _defineProperty({}, theme.breakpoints.up("sm"), {
      maxWidth: "1150px"
    }),
    maxWidth770: _defineProperty({
      maxWidth: "343px"
    }, theme.breakpoints.up("md"), {
      maxWidth: "770px"
    }),
    cardSubtitle: {
      textAlign: "left"
    },
    cardSpace: {
      marginBottom: theme.spacing(1)
    },
    ctaFont: {
      fontSize: "16px !important"
    },
    ctaDefaultColor: {
      color: theme.palette.grey[800]
    }
  };
});
var Tiles1 = function Tiles1(_ref) {
  var bgColor = _ref.bgColor,
    imageTitle = _ref.imageTitle,
    imageUrl = _ref.imageUrl,
    title = _ref.title,
    subtitle = _ref.subtitle,
    gridSpacing = _ref.gridSpacing,
    gridColumns = _ref.gridColumns,
    items = _ref.items;
  var classes = useStyles();
  var _useBreakpoints = useBreakpoints(),
    isExtraSmallScreen = _useBreakpoints.isExtraSmallScreen,
    isSmallScreen = _useBreakpoints.isSmallScreen;
  var gridContent = items === null || items === void 0 ? void 0 : items.map(function (item, index) {
    var _item$cta, _item$cta2, _item$cta3, _item$cta4;
    return /*#__PURE__*/React__default.createElement(Grid, {
      item: true,
      key: index,
      xs: 12,
      sm: 6,
      md: 12 / gridColumns,
      className: classes.cardSpace
    }, /*#__PURE__*/React__default.createElement(Card, {
      className: gridColumns === 2 && !isExtraSmallScreen() ? clsx(_defineProperty(_defineProperty({}, classes.cardLayoutEven, index % 2 === 0), classes.cardLayoutOdd, index % 2 !== 0)) : classes.cardLayout
    }, /*#__PURE__*/React__default.createElement(CardContent, {
      className: classes.cardContentStyle
    }, /*#__PURE__*/React__default.createElement(Box, null, (item === null || item === void 0 ? void 0 : item.imageUrl) && /*#__PURE__*/React__default.createElement(LazyLoadImage, {
      className: classes.gridImg,
      src: retrieveContentfulImage(item.imageUrl, {
        width: 120,
        height: 120
      }),
      alt: (item === null || item === void 0 ? void 0 : item.imageTitle) || "tile image"
    }), (item === null || item === void 0 ? void 0 : item.title) && /*#__PURE__*/React__default.createElement(Typography, {
      variant: "h5",
      component: "div",
      className: classes.cardTitle
    }, item.title), (item === null || item === void 0 ? void 0 : item.description) && /*#__PURE__*/React__default.createElement("div", {
      className: classes.cardSubtitle
    }, /*#__PURE__*/React__default.createElement(CustomRichTextFromMarkdown, {
      markdownString: item.description
    })))), (item === null || item === void 0 || (_item$cta = item.cta) === null || _item$cta === void 0 ? void 0 : _item$cta.url) && (item === null || item === void 0 || (_item$cta2 = item.cta) === null || _item$cta2 === void 0 ? void 0 : _item$cta2.label) && /*#__PURE__*/React__default.createElement(Box, {
      width: "100%",
      mt: "auto",
      pb: 5
    }, /*#__PURE__*/React__default.createElement(Link, {
      href: item === null || item === void 0 || (_item$cta3 = item.cta) === null || _item$cta3 === void 0 ? void 0 : _item$cta3.url,
      underline: "always",
      className: clsx(classes.ctaFont, item !== null && item !== void 0 && item.cta.linkColour ? undefined : classes.ctaDefaultColor),
      style: item !== null && item !== void 0 && item.cta.linkColour ? {
        color: "#".concat(item === null || item === void 0 ? void 0 : item.cta.linkColour)
      } : undefined,
      target: "_blank"
    }, item === null || item === void 0 || (_item$cta4 = item.cta) === null || _item$cta4 === void 0 ? void 0 : _item$cta4.label))));
  });
  return /*#__PURE__*/React__default.createElement(Box, {
    bgcolor: bgColor
  }, /*#__PURE__*/React__default.createElement(Grid, {
    container: true,
    direction: "column",
    alignItems: "center",
    justify: "center",
    className: classes.box
  }, imageUrl && /*#__PURE__*/React__default.createElement(Grid, {
    item: true
  }, /*#__PURE__*/React__default.createElement(LazyLoadImage, {
    className: classes.img,
    src: retrieveContentfulImage(imageUrl, {
      width: 180,
      height: 180
    }),
    alt: imageTitle || "icon"
  })), title && /*#__PURE__*/React__default.createElement(Grid, {
    item: true
  }, /*#__PURE__*/React__default.createElement(Typography, {
    variant: "h1",
    component: "h2",
    className: classes.mb2
  }, title)), subtitle && /*#__PURE__*/React__default.createElement(Grid, {
    item: true,
    className: classes.maxWidth770
  }, /*#__PURE__*/React__default.createElement(Typography, {
    variant: "body1",
    color: "textSecondary",
    className: clsx(_defineProperty(_defineProperty({}, classes.mb5, !(isExtraSmallScreen() || isSmallScreen())), classes.mb4, isExtraSmallScreen() || isSmallScreen()))
  }, subtitle)), /*#__PURE__*/React__default.createElement(Grid, {
    item: true,
    className: classes.maxWidth1150
  }, /*#__PURE__*/React__default.createElement(Grid, {
    container: true,
    spacing: gridSpacing
  }, gridContent))));
};
Tiles1.propTypes = {
  bgColor: PropTypes__default.string,
  imageTitle: PropTypes__default.string,
  imageUrl: PropTypes__default.string,
  title: PropTypes__default.string,
  subtitle: PropTypes__default.string,
  gridColumns: PropTypes__default.oneOf([1, 2, 3, 4, 6, 12]),
  gridSpacing: PropTypes__default.number,
  items: PropTypes__default.arrayOf(PropTypes__default.shape({
    title: PropTypes__default.string,
    description: PropTypes__default.string,
    imageTitle: PropTypes__default.string,
    imageUrl: PropTypes__default.string,
    cta: PropTypes__default.shape({
      label: PropTypes__default.string,
      url: PropTypes__default.string
    })
  }))
};

export { Tiles1 as default };
//# sourceMappingURL=Tiles1.js.map
